import React from "react";

export default function BlogPostNewsletter() {
  return (
    <section className="max-w-6xl mx-auto px-6 pb-16">
      <div className="rounded-[28px] p-8 sm:p-10 text-white bg-gradient-to-r from-[#430796] to-[#8D13DB]">
        <h2 className="text-xl sm:text-2xl font-bold mb-2">
          Get Weekly Travel Inspiration
        </h2>
        <p className="text-sm text-white/85 leading-relaxed mb-6">
          Join thousands of solo travelers and get the best travel stories,
          tips, and exclusive guides every week.
        </p>
        <form
          className="flex items-center gap-2 max-w-md bg-white rounded-[13px] p-1.5"
          onSubmit={(e) => e.preventDefault()}
        >
          <input
            type="email"
            placeholder="Enter your email"
            className="flex-1 min-w-0 bg-transparent px-4 py-2.5 text-sm text-slate-500 placeholder:text-slate-400 focus:outline-none"
          />
          <button
            type="submit"
            className="bg-[#7209B7] text-white font-semibold text-sm px-6 py-2.5 rounded-[13px] hover:opacity-90 transition-opacity shrink-0"
          >
            Subscribe
          </button>
        </form>
      </div>
    </section>
  );
}